import { shimTextEncoding } from 'utils/shimTextEncoding';

export const loadShims = async () => {
  if (!window.TextDecoder) {
    await shimTextEncoding();
  }
  // findLastIndex polyfill
  // It's been available in all major browsers since 2022, but this is a cheap insurance policy
  if (!Array.prototype.findLastIndex) {
    // eslint-disable-next-line no-extend-native
    Object.defineProperty(Array.prototype, 'findLastIndex', {
      value: function findLastIndex(
        callback: (value: any, index: number, array: any[]) => unknown,
        thisArg: any,
      ) {
        for (let i = this.length - 1; i >= 0; i--) {
          if (callback.call(thisArg, this[i], i, this)) return i;
        }
        return -1;
      },
      writable: true,
      enumerable: false,
      configurable: true,
    });
  }
};
